import type { PersonalData, SomeoneElseData } from "../types/bookingCreation";

/**
 * The recipient contact a booking is sent with, or `undefined` for none — the
 * ONE answer for every submit path (Stripe and no-payment initialisation, and
 * the room/venue request flow).
 *
 * - Room rental's "booking for: someone else": that person. Collected on the
 *   personal-data step and, before this, never sent — the guest was lost.
 * - The p2p / key-handover recipient (`recipientData`), when one was entered.
 * - Otherwise none. `recipientData` starts out as empty strings, which the old
 *   "every value is null" check never recognised as empty, so every booking
 *   without a recipient sent a blank one.
 */
export const bookingRecipient = (bookingCreation: {
  isForSomeoneElse: boolean;
  someoneElseData: SomeoneElseData;
  recipientData: PersonalData;
}): PersonalData | undefined => {
  if (bookingCreation.isForSomeoneElse) {
    const { firstName, lastName, email } = bookingCreation.someoneElseData;
    return {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      phone: "",
      newsletterConsent: false,
      isAgreed: false,
    };
  }
  const { firstName, lastName, email, phone } = bookingCreation.recipientData;
  const entered = [firstName, lastName, email, phone].some(
    (value) => typeof value === "string" && value.trim() !== ""
  );
  return entered ? bookingCreation.recipientData : undefined;
};
